import source from '../downloaded/cutscenes.json' assert { type: 'json' };

export const items = source.map((row) => row.paragraph);
